module.exports = __webpack_public_path__ + "img/16m001-01.36ba2b59.jpg";